/* eslint-disable no-continue */
/* eslint-disable no-plusplus */
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import * as S from "./styles";

import { Simulate } from "react-dom/test-utils";
import CompleteBox from "../../components/CompleteBox";
import PartnerLink from "../../components/PartnerLink";
import PageFooter from "../../components/PageFooter";
import axios from "axios";
import { FormProps } from "../../store";
import { API_URL } from "../../config";

const Complete = () => {
  const location = useLocation();

  const [completeText, setCompleteText] = useState<string>("");
  const [completeTitle, setCompleteTitle] = useState<string>("");
  const [partnerLink, setPartnerLink] = useState<string>("");
  const [partnerImage, setPartnerImage] = useState<string>("");
  const [partnerName, setPartnerName] = useState<string>("");
  const { programIdOrCustomUrl } = useParams();

  const getSectionProps = async () => {
    const response = await axios.get(`${API_URL}/forms/${programIdOrCustomUrl}`);
    const form = response.data as FormProps;

    setPartnerLink(form.partnerLink);
    setPartnerImage(form.partnerImage ?? "");
    setPartnerName(form.partnerName);
    setCompleteTitle(form.completeTitle);
    setCompleteText(form.completeText ?? "");
  };

  useEffect(() => {
    getSectionProps();
  }, []);

  return (
    <div>
      <PartnerLink link={partnerLink} image={partnerImage} />
      <CompleteBox completeTitle={completeTitle} completeText={completeText} />
      <PageFooter partnerName={partnerName} />
    </div>
  );
};

export default Complete;
